/* -------------------------- Design imports start -------------------------- */
import { Box, Stack } from '@mui/material'
/* --------------------------- Design imports end --------------------------- */

/* ------------------------ Functional imports start ------------------------ */
import type * as Communicator from '@hoops/web-viewer'
import { type MutableRefObject } from 'react'
import HoopsExplodeButton from '../widgets/HoopsExplodeButton'
import { type HoopsCADViewerToolbarProps } from './types'
/* ------------------------- Functional imports end ------------------------- */

/* -------------------------------------------------------------------------- */
/*                               Start Component                              */
/* -------------------------------------------------------------------------- */
export default function HoopsCADViewerToolbar(props: HoopsCADViewerToolbarProps): JSX.Element | null {
  const { webViewer, position } = props

  if (!webViewer.current) {
    return null
  }

  const defaultPosition = {
    left: '50%',
    bottom: '12px',
  }

  const finalPosition = {
    ...defaultPosition,
    ...position,
  }

  return (
    <Box
      id="cadViewerToolbar"
      sx={{
        position: 'absolute',
        padding: '12px',
        bottom: finalPosition.bottom,
        left: finalPosition.left,
        transform: 'translateX(-50%)',
        transition: 'left 250ms ease-out',
        borderRadius: '5px',
        backgroundColor: 'white',
        boxShadow: 2,
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <HoopsExplodeButton hoopsExplodeManager={webViewer.current.explodeManager} />
        {/* Placeholder for additional tools like Measure */}
      </Stack>
    </Box>
  )
}
